var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { MouseCursor } from '../../twig/components/MouseCursor';
export class DataStore {
    static init(mode) {
        return __awaiter(this, void 0, void 0, function* () {
            this.mode = mode;
            yield this.load();
        });
    }
    static get(key) {
        if (key) {
            return this.data[key];
        }
        else {
            return this.data;
        }
    }
    static update(key_1, value_1) {
        return __awaiter(this, arguments, void 0, function* (key, value, noDebounce = false) {
            if (key == 'answers') {
                if (!this.data[key])
                    this.data[key] = {};
                this.data[key][value.id] = value.value;
            }
            else {
                this.data[key] = value;
            }
            if (noDebounce) {
                yield this.save();
            }
            else {
                clearTimeout(this.lastSave);
                this.lastSave = window.setTimeout(() => {
                    this.save();
                }, 500);
            }
        });
    }
    static load() {
        return __awaiter(this, arguments, void 0, function* (localParsing = false) {
            if (this.mode == 'local' || localParsing) {
                const localData = localStorage.getItem('form-data');
                let parsingSuccess = false;
                try {
                    this.data = JSON.parse(localData);
                    if (this.data)
                        parsingSuccess = true;
                }
                catch (e) { }
                if (!parsingSuccess) {
                    this.data = {
                        started: false
                    };
                }
                if (!localParsing)
                    this.save();
            }
            else {
                const formID = $('.form-reference').data('id');
                const formKey = $('.form-reference').data('key');
                if (formID === '')
                    return;
                this.data = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'load_form',
                        'form_id': formID,
                        'key': formKey
                    },
                    dataType: 'json'
                });
            }
        });
    }
    static save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.mode == 'local') {
                localStorage.setItem('form-data', JSON.stringify(this.data));
            }
            else {
                MouseCursor.setLoadingState(true);
                $('#icon-saving').removeClass('d-none');
                $('.form-navigation a').addClass('disabled');
                yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'save_form',
                        'form_id': $('.form').data('id'),
                        'data': JSON.stringify(this.data)
                    },
                    dataType: 'text'
                });
                MouseCursor.setLoadingState(false);
                $('.form-navigation a').removeClass('disabled');
                $('#notification-save-done').removeClass('d-none');
                window.clearTimeout(this.saveNotificationTimeoutID);
                this.saveNotificationTimeoutID = window.setTimeout(() => {
                    $('#notification-save-done').addClass('d-none');
                }, 2000);
            }
        });
    }
    static clear() {
        localStorage.removeItem('form-data');
        this.load();
    }
    static transfert() {
        return __awaiter(this, void 0, void 0, function* () {
            /*if ($('body').hasClass('logged-in') && localStorage.getItem('form-data')) {
              let redirect = false;
        
              this.load(true);
        
              if (this.data.company !== '') {
                $('#alert-importing').removeClass('d-none')
        
                await $.httpRequest({
                  url: '/wp-admin/admin-ajax.php',
                  type: 'POST',
                  body: {
                    'action': 'save_form',
                    'data': JSON.stringify(this.data)
                  },
                  dataType: 'text'
                });
        
                $('#alert-imported').removeClass('d-none');
        
                redirect = true;
              }
        
              localStorage.removeItem('form-data')
        
              if (redirect) location.href = location.href + '?imported=true';
            }*/
        });
    }
}
DataStore.lastSave = 0;
DataStore.saveNotificationTimeoutID = 0;
